'use strict';

var _ = require('lodash');

function AutohideDirective () {
  function link(scope, el) {
    var domEl = el[0];
    var hiddenChildren = {};
    var newHiddenChildren = {};
    scope.autohideArrayEl = [];

    scope.$on('RELOAD_AUTOHIDE', function() {
      buildIndex();
      recalculate();
    });

    function buildIndex() {
      scope.autohideArrayEl = _.chain(domEl.querySelectorAll('[sb-autohide-priority]'))
        .map(function(node) {
          node.classList.remove('-hidden');

          return {
            el: node,
            priority: parseInt(node.getAttribute('sb-autohide-priority')),
            id: node.getAttribute('sb-autohide-id'),
            width: null, // setted each tick
            visible: true
          };
        })
        .sortBy('priority')
        .value();
    }

    function getElTotalWidth(el) {
      var computedStyle = window.getComputedStyle(el);
      var totalWidth = el.getBoundingClientRect().width + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
      return totalWidth;
    }

    function recalculate() {
      var width = domEl.clientWidth;
      var allChildren = _.map(domEl.children, function(node) {
        return {
          el: node,
          width: getElTotalWidth(node)
        };
      });

      var totalChildWidth = _.reduce(allChildren, function(res, node) {
        return res + (node.el.classList.contains('-hidden') ? 0 : node.width);
      }, 0);

      scope.autohideArrayEl = _.map(scope.autohideArrayEl, function(node) {
        return _.assign({}, node, {
          width: getElTotalWidth(node.el),
          visible: !node.el.classList.contains('-hidden')
        });
      });

      var widthDebt = width - totalChildWidth - 1;
      if (widthDebt < 0) {
        _.forEach(scope.autohideArrayEl, function(node) {
          if (node.visible === false || widthDebt >= 0) {
            return;
          }

          widthDebt = widthDebt + node.width;
          node.el.classList.add('-hidden');
          node.visible = false;
        });
      } else {
        _.forEachRight(scope.autohideArrayEl, function(node) {
          if (node.visible === true || widthDebt < node.width) {
            return;
          }

          widthDebt = widthDebt - node.width;
          node.el.classList.remove('-hidden');
          node.visible = true;
        });
      }

      newHiddenChildren = _.map(scope.autohideArrayEl, function(el) {
        return {
          id: el.id,
          visible: el.visible
        };
      });

      // diff the new state of hidding
      if (!_.isEqual(hiddenChildren, newHiddenChildren)) {
        hiddenChildren = newHiddenChildren;

        // make sure that we only execute this if we have a function on the parent
        if (_.isFunction(scope.sbAutohideOnChildHide) && _.isFunction(scope.sbAutohideOnChildHide())) {
          scope.sbAutohideOnChildHide()(newHiddenChildren);
        }
      }
    }

    buildIndex();
    recalculate();

    window.addEventListener('resize', _.debounce(recalculate, 16, {
      leading: true,
      trailing: true
    }));
  }

  return {
    scope: {
      sbAutohideOnChildHide: '&'
    },
    link: link,
    restrict: 'A'
  };
}

module.exports = AutohideDirective;



//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/saturn-autohide-booster/src/AutohideDirective.js
// module id = 771
// module chunks = 0